<!--美育浸润-->
<template>
    <div class="guide-nav-content" >
        <div class="guide-ext-container" v-show="videoMode==='beautyEdu'" v-loading="loading">
            <div class="museum-title-container">
                <div class="l-museum-title-container">
                    <div class="l-t-museum-title-container">美育浸润</div>
                    <div class="l-b-museum-title-container">十四个系列视频资源</div>
                </div>
                <div class="r-museum-title-container">
                    <div class="back-btn-container" @click="backReadMuseum" >⇦返回</div>
                </div>
            </div>

            <div class="museum-item-container">
                <div class="museum-item-card" v-for="(item,index) in filteredList" :key="index">
                    <div class="museum-item-card-content">
                        <div class="museum-item-40 mf1">{{item.itemName}}</div>
                        <div class="museum-item-20 labor-mf2">{{item.itemClassify}}</div>
                        <div class="museum-item-40 dis-align">
                            <div class="resource-btn" @click="viewHumVideo(item)">查看资源</div>
                        </div>
                    </div>
                </div>
                <div class="empty-container" v-if="!loading && filteredList.length===0">
                    <dataEmpty title="暂无资源"/>
                </div>
            </div>

        </div>
        <!--视频子类-->
        <div class="detail-mode" v-show="videoMode==='beautyClassify'">
            <beauty-classify :item-id="itemInfo.itemId"
                             :mark-info="innerMarkInfo"
                             @back-model-page="backModelPage"
                             @view-video-list="viewVideoList"/>
        </div>
        <!--子类视频列表-->
        <div class="detail-mode" v-show="videoMode==='beautyVideoList'">
            <beauty-video-list :item-id="classifyInfo.itemId"
                               :item-name="classifyInfo.itemClassifyName"
                               :mark-info="innerMarkInfo"
                               @back-model-page="backModelPage"
                               @view-video-info="viewVideoInfo"/>
        </div>
        <!--视频详情-->
        <div class="detail-mode" v-show="videoMode==='beautyVideoInfo'">
            <beauty-video-info :video-id="videoInfo.videoId"
                               :mark-info="innerMarkInfo"
                               @back-model-page="backModelPage"/>
        </div>
    </div>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import {humItemList} from "@/api/admin/museum";
import dataEmpty from "@/components/dataEmpty.vue";
import beautyClassify from "@/components/newMuseum/bymy/beautyClassify.vue";
import beautyVideoList from "@/components/newMuseum/bymy/beautyVideoList.vue";
import beautyVideoInfo from "@/components/newMuseum/bymy/beautyVideoInfo.vue";

export default {
    name: "beautyEdu",
    components: {beautyClassify, beautyVideoList, beautyVideoInfo, dataEmpty},
    data() {
        return {
            showMode:'beautyEdu',
            serviceUrl,
            loading:false,
            museumKey:'1',
            filteredList:[],
            itemInfo:{},
            classifyInfo:{},
            videoInfo:{},
            innerMarkInfo:'',
            videoMode:"beautyEdu"
        }
    },
    computed: {},
    props:{
        markInfo:{
            type: String,
            default:null
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.showMode = 'beautyEdu';
            this.videoMode = 'beautyEdu';
            this.queryHumItemList();
        },
    },
    created() {
        this.queryHumItemList();
    },
    mounted(){},
    methods: {
        /*查询视频分类*/
        queryHumItemList(){
            this.loading = true;
            humItemList({museumKey:this.museumKey}).then(res => {
                if (res.data.code===1){
                    this.filteredList = res.data.data || [];
                }else {
                    this.$message.error(res.data.msg);
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        backReadMuseum(){
            this.videoMode = 'beautyEdu'
            this.$emit('back-read-museum', "homePage");
        },
        /*查看主题视频子类*/
        viewHumVideo(item){
            this.itemInfo = item;
            this.innerMarkInfo = new Date() + '';
            this.showMode = 'beautyClassify'
            this.videoMode = 'beautyClassify'
        },
        /*查看子类视频列表*/
        viewVideoList(item){
            this.classifyInfo = item;
            this.innerMarkInfo = new Date() + '';
            this.videoMode = 'beautyVideoList'
        },
        /*查看视频详情*/
        viewVideoInfo(item){
            this.videoInfo = item;
            this.innerMarkInfo = new Date() + '';
            this.videoMode = 'beautyVideoInfo'
        },
        /*子组件返回*/
        backModelPage(val){
            if (val === 'beautyClassify'){
                this.videoMode = 'beautyClassify'
            }else if (val === 'beautyVideoList'){
                this.videoMode = 'beautyVideoList'
            }else {
                this.videoMode = 'beautyEdu'
            }
            this.showMode = this.videoMode;
        }
    }
}

</script>

<style scoped>
.guide-nav-content{
    width: 100%;
    height: auto;
}
.guide-ext-container{
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.museum-title-container{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
}
.l-museum-title-container{
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.l-t-museum-title-container{
    font-weight: bold;
    color: #ff7f2e;
    font-size: 18px;
    line-height: 1.4;
}
.l-b-museum-title-container{
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    flex-shrink: 0;
    display: flex;
    align-items: center;
}
.back-btn-container{
    flex-shrink: 0;
    height: 32px;
    padding: 0 14px;
    background: #ff7f2e;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
}

.museum-item-container{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 20px;
    padding: 10px 28px;
    box-sizing: border-box;
}
.museum-item-card{
    width: calc((100% - 40px) / 3);
    height: 130px;
    border-left: 5px solid #ff7f2e;
    box-shadow: inset 0 0 2px rgba(0,0,0,0.22);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.museum-item-card-content{
    width: 90%;
    height: 80%;
}
.museum-item-40{
    width: 100%;
    height: 40%;
}
.mf1{
    color: #ff7f2e;
    font-weight: bold;
    display: flex;
    align-items: center;
    font-size: clamp(16px, 12cqh, 18px);
}
.labor-mf2{
    color: #9a9a9a;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.museum-item-20{
    width: 100%;
    height: 20%;
}
.resource-btn{
    width: 100%;
    height: 70%;
    background: #ff7f2e;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 6px;
    /* 核心居中代码 */
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    cursor: pointer;
}
.dis-align{
    display: flex;
    justify-items: center;
    align-items: center;
}

.empty-container{
    width: 100%;
}

.detail-mode{
    width: 100%;
    height: auto;
}
</style>
